import { render, staticRenderFns } from "./OrderStatusChip.vue?vue&type=template&id=73f044a2&"
import script from "./OrderStatusChip.vue?vue&type=script&lang=ts&"
export * from "./OrderStatusChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports